const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SocialSecurityNo\\.[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_6[0].PrintedName[0]"
     },
     docArea: {
        value: "",
        dbqName: ""
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_6[0].Date[0]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_6[0].LicenseNumber[0]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_6[0].Phoneandfaxno\\.[0]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_6[0].Address[0]"
    },
    diagnosisDate : [       
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis1[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis1[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis2[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis2[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis3[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis3[0]",
        },        
    ]

}

export default ssn ;